<template>
  <div class="flex items-center">

    <div
      ref="chart"
      class="chart pie clickable mr-3"
      style="height: 160px; width: 160px;"
      @click="handleChartClick"
    ></div>

    <div v-if="chartData" class="flex-1 pl-6" style="padding-right:50%;">
      <ul>
        <li
          v-for="(item, index) in chartData.series"
          :key="index"
          class="flex items-center cursor-pointer"
          @click="$emit('rowClick', item.meta)"
        >
          <div class="w-full">
            <div class="w-6 h-6 inline-block rounded align-middle my-1 mr-2"
                 :class="['bg-analytics-'+item.className]"></div>
            {{ item.label }}
          </div>
          <div class="w-16 text-right">
            {{ $n(item.value, 'analyticsInteger') }}
          </div>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
  import Chartist from 'chartist';
  import 'chartist/dist/chartist.min.css';

  export default {
    props: {
      chartData: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      chartist: null,
    }),

    computed: {
      chartDataWithZeroesRemoved() {
        return {
          ...this.chartData,
          series: this.chartData.series.filter(item => item.value > 0),
        };
      },
    },

    watch: {
      chartData() {
        if (this.chartist) {
          this.destroyChart();
        }

        if (this.chartData) {
          this.drawChart();
        }
      },
    },

    mounted() {
      if (this.chartData) {
        this.drawChart();
      }
    },

    destroyed() {
      this.destroyChart();
    },

    methods: {
      handleChartClick({ target }) {
        if (target.tagName === 'path' && target.classList.contains('ct-slice-pie')) {
          this.$emit('chartClick', Chartist.deserialize(target.getAttribute('ct:meta')));
        }
      },

      destroyChart() {
        if (this.chartist) {
          this.chartist.detach();
        }

        this.chartist = null;
      },

      drawChart() {
        const total = this.chartData.series.map(item => item.value)
          .reduce((a, b) => a + b, 0);

        this.chartist = new Chartist.Pie(
          this.$refs.chart,
          this.chartDataWithZeroesRemoved,
          {
            labelInterpolationFnc: value => this.$n(value / total, 'analyticsPercentage')
              .replace(' %', '%'),
          },
        );
        this.chartist.supportsForeignObject = false; // this is needed to make png export possible
      },
    },
  };
</script>
